/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/defense_global_dome': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 29C8.832 29 3 23.168 3 16S8.832 3 16 3s13 5.832 13 13-5.832 13-13 13zm0-24C9.935 5 5 9.935 5 16s4.935 11 11 11 11-4.935 11-11S22.065 5 16 5z"/><path pid="1" d="M16 25c-4.963 0-9-4.038-9-9s4.037-9 9-9 9 4.038 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.14-7 7s3.141 7 7 7 7-3.14 7-7-3.141-7-7-7z"/><path pid="2" d="M14 16c0 2.25 2 3 2 3s2-.75 2-3v-3h-4v3zM8.5 32H0v-8.5h1V31h7.5zM14.27 31h3.462v1H14.27zM32 32h-8.5v-1H31v-7.5h1zM31 14.27h1v3.461h-1zM32 8.5h-1V1h-7.5V0H32zM14.269 0h3.462v1h-3.462zM1 8.5H0V0h8.5v1H1zM0 14.269h1v3.461H0z"/>'
  }
})
